
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSReturnItemsBOMGrid extends Serenity.EntityGrid<POSReturnItemsBOMRow, any> {
        protected getColumnsKey() { return 'Retail.POSReturnItemsBOM'; }
        protected getDialogType() { return POSReturnItemsBOMDialog; }
        protected getIdProperty() { return POSReturnItemsBOMRow.idProperty; }
        protected getInsertPermission() { return POSReturnItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return POSReturnItemsBOMRow.localTextPrefix; }
        protected getService() { return POSReturnItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}